import { DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  Combo2Service,
  ComboService,
  DesignphotoService,
  DCService,
} from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./AddbitDcInward.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class addEditJobInward implements OnInit {
  row: any;
  data: any;
  damrow: any;
  balrow: any;
  styleList1: any;
  width: any;
  designdata: any = {};
  varietyList = [];
  varietyList1 = [];
  stocklist = ["BIT", "BULK"];
  empty_ind: any;
  sizeList = [];
  dcDetails = [];
  desList = [];
  tempList = [];
  designExists: string = "";
  runningDesigns: number = 0;
  runningDesignsTemp: number = 0;
  colorList: any;
  designnoList = [];
  tempDesignnoList = [];
  codeList: any;
  brandList = ["OLIVE", "JOB", "EXPOSE", "OTHER BRANDS"];
  qualityList = ["PC", "COTTON", "LINEN", "JUST LINEN", "SATIN", "SILK"];
  Delivery: boolean = false;
  brand_check: boolean = false;
  show_button: boolean = false;
  show_balbutt: boolean = false;
  job_type_check: boolean = false;
  inw_type_check: boolean = false;
  expose_type_check: boolean = false;
  partyList = [];
  seasonList = [];
  shirttypeList = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  salesdata = {
    inward_no: "",
    brand_name: "EXPOSE",
    inward_date: "",
    brand_name_others: "",
    Purchased_By: "",
    purchase_date: "",
    prod_rate: 0,
    rate: 0,
    remarks: "",
    style: "",
    total_design: 0,
    width: 0,
    dc_type: "",
    rec_pcs: 0,
    totqty: 0,
    dqty: 0,
    tot_recpcs: 0,
    totInw_pcs: 0
  };
  widthList = ["36", "44", "58"];
  bal_bitList = [];
  damageList = [];
  designList = [
    {
      design_no: "",
      fullQty: 0,
      halfQty: 0,
      color: "",
      mtr: 0,
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      bf28: 0,
      bf30: 0,
      bf32: 0,
      bf34: 0,
      bf36: 0,
      bh28: 0,
      bh30: 0,
      bh32: 0,
      bh34: 0,
      bh36: 0,
      bfqty: 0,
      bhqty: 0,
      totqty: 0,
      design_id: 0,
      variety_type: "",
      prod_rate: 0,
      width: 0,
      qty: 0,
    },
  ];
  mode: string;
  saveEvent: any;
  // brandList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.salesdata = designdata;
    if (this.mode == "View") {
      console.log(this.salesdata)
      this.salesdata.inward_date = this.datePipe.transform(
        designdata.inw_date,
        "yyyy-MM-dd"
      );
      this.salesdata.inward_no = designdata.inw_no;
      this.salesdata.rec_pcs = designdata.totInw_pcs;
      this.salesdata.brand_name = designdata.brand;

      this.loadInwdesignList(designdata.inw_id);
    } else if (this.mode == "Inward") {
      this.salesdata.brand_name = designdata.brand;
      this.getDesNoToDefault();
      this.getDcdesignNo(designdata.dc_id);
      this.salesdata.inward_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.brandList = [];
      this.inw_type_check = true;

      this.getAuto();
      this.salesdata.brand_name = designdata.brand;
      this.expose_type_check = true;
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private dcService: DCService,
    private comboservice: ComboService,
    private designservice: DesignphotoService,
    private combo: Combo2Service,
    private change: ChangeDetectorRef
  ) {
    this.row = {
      design_no: "",
      type: "",
      typeid: "",
      rangefrom: "",
      rangeto: "",
      color: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      bf28: 0,
      bf30: 0,
      bf32: 0,
      bf34: 0,
      bf36: 0,
      bh28: 0,
      bh30: 0,
      bh32: 0,
      bh34: 0,
      bh36: 0,
      bfqty: 0,
      bhqty: 0,
      totqty: 0,
      variety_type: "",
      prod_rate: 0,
      width: 0,
      qty: 0,
    };
    this.damrow = {
      dam_design: "",
      dshade: "",
      dsize: "",
      dqty: 0,
    };
    this.balrow = {
      bal_design: "",
      bal_mtr: 0,
      stock_type : "",
      bal_barcode : ""

    };
  }
  ngOnInit() {
    this.tableScroll();
    this.getVarietyList();
    if (this.mode == "Add") {
      this.salesdata.inward_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      // this.getAuto();
    }
    // this.getTypeList();
    // this.agentCombo();
    // this.getDesignNoList();
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#brand_name").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      nextEl = "design_no-0";
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  // onGoToNextFld($event, fld, ind) {
  //   if (fld == "color") {
  //     let totdes = 0;
  //     const designlist = [];
  //     for (let i = 0; i < this.dcList.length; i++) {
  //       const design = this.dcList[i].design_no;
  //       if (design != "") {
  //         if (designlist.indexOf(design) == -1) {
  //           designlist.push(design);
  //           totdes++;
  //         }
  //       }
  //     }
  //     this.dcdata.total_design = totdes;
  //   }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    let len = this.damageList.length;
    if((this.salesdata.dc_type == 'BIT' && fld == "design_no") || fld == "gooddes"){
        nxtInd = nxtInd + 1;
      $("#"  + "design_no" + "-" + nxtInd).focus();
  
      return false;
    }
    if(this.salesdata.dc_type == 'BULK' && fld == "design_no" && this.salesdata.style == 'BABLA'){
 
      $("#" +  "bf28" + "-" + ind).focus();
  
      return false;
    }
    if(this.salesdata.dc_type == 'BULK' && fld == "qty"){
 
      $("#" +  "prod_rate" + "-" + ind).focus();
  
      return false;
    }
    else if(this.salesdata.dc_type == 'BULK' && fld == "design_no" && this.salesdata.style == 'SHIRT'){
   
      $("#" + "f36" + "-" + ind).focus();
  
      return false;
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }
  onGoToFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    let len = this.bal_bitList.length;

    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }
  loadInwdesignList(id) {
    let params = {
      inw_id: id
    };
    this.dcService.loadInwdesignList(params).then((res: any) => {
      this.designList = res.data;
      this.damageList = res.damdata;
      this.bal_bitList = res.baldata;

      // this.calcRate();
      this.change.detectChanges();
    });
  }
  doSetTimeout(res, i) {
    i = i + 1;
    setTimeout(() => {
      for (var k = 0; k < 10; k++) {
        this.designList.push(res[i + k]);
      }
    }, 500);
  }
  calcTotal($event, ind) {
    let nan = function (no) {
      if (no == "" || no == null || no == undefined) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };

    let item = this.designList[ind];
    let fqty =
      nan(item.f36) +
      nan(item.f38) +
      nan(item.f40) +
      nan(item.f42) +
      nan(item.f44) +
      nan(item.f46);
    let hqty =
      nan(item.h36) +
      nan(item.h38) +
      nan(item.h40) +
      nan(item.h42) +
      nan(item.h44) +
      nan(item.h46);
    this.designList[ind].fqty = parseFloat("" + fqty);
    this.designList[ind].hqty = parseFloat("" + hqty);
    this.designList[ind].totqty = parseFloat(
      "" +
      (item.f36 +
        item.f38 +
        item.f40 +
        item.f42 +
        item.f44 +
        item.f46 +
        item.h36 +
        item.h38 +
        item.h40 +
        item.h42 +
        item.h44 +
        item.h46)
    );
    this.calcRate();
  }

  calcRate() {

    let item = this.designList;
    let totqty = 0
    if (this.salesdata.dc_type == "BULK") {
      for (let i = 0; i < item.length; i++) {
        totqty += Number(item[i].totqty);
      }
    }
    else {
      for (let i = 0; i < item.length; i++) {
        totqty += Number(item[i].qty);
      }
    }
    this.salesdata.totqty = totqty;

  }
  calcDamqty() {
    let item = this.damageList;
    let totqty = 0
    for (let i = 0; i < item.length; i++) {
      totqty += Number(item[i].dqty);
    }

    this.salesdata.dqty = totqty;
    console.log(this.salesdata.dqty);

  }
  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  deleteRow(ind) {
    this.designList.splice(ind, 1);
    this.setRunningDesignno();
  }
  Adddamrow(ind) {
    this.show_button = false;
    let dam_design = this.damageList[ind].dam_design;

    // this.desList = this.desList.filter((el) => el.des != dam_design);
    console.log(this.desList);
    if (dam_design != "") {
      let drow = Object.assign({}, this.damrow);
      this.damageList.push(drow);
    }
  }
  Addbalrow(ind) {
    this.show_balbutt = false;
    let bal_design = this.bal_bitList[ind].bal_design;

    // this.desList = this.desList.filter((el) => el.des != bal_design);
    console.log(this.desList);
    if (bal_design != "") {
      let brow = Object.assign({}, this.balrow);
      this.bal_bitList.push(brow);
    }
  }
  setRunningDesignno() {
    let tempDesign = this.runningDesignsTemp;
    this.runningDesigns = tempDesign;
    console.log(this.designList);
    this.designList.forEach((el, ind) => {
      if (this.salesdata.brand_name == "LEO BOYS") {
        el.design_no = "LB-" + (Number(this.runningDesigns) + ind);
      }
      else if (this.salesdata.brand_name == "JOB") {
        el.design_no = "JB-" + (Number(this.runningDesigns) + ind);
      } 
  else if (this.salesdata.brand_name == "LE MERITIN") {
        el.design_no = "LM-" + (Number(this.runningDesigns) + ind);
      }  
   else if (this.salesdata.brand_name == "MARX") {
        el.design_no = "MX-" + (Number(this.runningDesigns) + ind);
      }
       else {
        el.design_no = "OL-" + (Number(this.runningDesigns) + ind);
      }
    });
  }

  onDeleteRow($event, fld, ind) {
    //     onDeleteRow(ind) {
    //  $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);
          // that.calcRate();
          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
          this.setRunningDesignno();
        }
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    let params = {
      trans_type: "SalesOrder",
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.dcService.getAutoNoJobdc(params).then((res: any) => {
      this.salesdata.inward_no = res;
      // this.oncheckemptyrow();
    });
  }
  // setRunningDesignno() {
  //     let tempDesign = this.runningDesignsTemp;
  //     this.runningDesigns = tempDesign;
  //     this.designList.forEach((el, ind) => {
  //       if (this.salesdata.brand_name == "LEO BOYS") {
  //         el.design_no = "LB-" + (Number(this.runningDesigns) + ind);
  //       } else {
  //         el.design_no = "OL-" + (Number(this.runningDesigns) + ind);
  //       }
  //     });
  //   }
  getDcdesignNo(type) {
    let params = {
      dc_id: type
    };
    this.dcService.getDcdesignNo(params).then((res: any) => {

      this.dcDetails = res.data;
      console.log(this.dcDetails);


    });


  }
  getDesNoToDefault() {
    let brand_prefix = "";
    if (this.salesdata.brand_name == "LEO BOYS") {
      brand_prefix = "LB-";
    } 
    else if (this.salesdata.brand_name == "JOB") {
      brand_prefix = "JB-";
    } 
    else if (this.salesdata.brand_name == "LE MERITIN") {
      brand_prefix = "LM-";
    } 
    else if (this.salesdata.brand_name == "MARX") {
      brand_prefix = "MX-";
    } 
    else {
      brand_prefix = "OL-";
    }
    let params = {
      brand: brand_prefix,
    };
    this.dcService.getDesNoToDefault(params).then((res: any) => {
      if (res.success) {
        this.runningDesigns = res.data.design_no;
        this.runningDesignsTemp = Number(res.data.design_no);
        if (this.salesdata.brand_name == "LEO BOYS") {
          this.designExists = "LB-" + res.data.design_no;
          this.designList[0].design_no = this.designExists;
        }
        else if (this.salesdata.brand_name == "JOB") {
          this.designExists = "JB-" + res.data.design_no;
          this.designList[0].design_no = this.designExists;
        }
        else if (this.salesdata.brand_name == "LE MERITIN") {
          this.designExists = "LM-" + res.data.design_no;
          this.designList[0].design_no = this.designExists;
        }
        else if (this.salesdata.brand_name == "MARX") {
          this.designExists = "MX-" + res.data.design_no;
          this.designList[0].design_no = this.designExists;
        }
        else {
          this.designExists = "OL-" + res.data.design_no;
          this.designList[0].design_no = this.designExists;
        }
      } else {
        this.runningDesigns = 100;
        this.runningDesignsTemp = 100;
        if (this.salesdata.brand_name == "LEO BOYS") {
          this.designExists = "LB-100";
          this.designList[0].design_no = this.designExists;
        } 
        else if (this.salesdata.brand_name == "JOB") {
          this.designExists = "JB-100";
          this.designList[0].design_no = this.designExists;
        } 
        else if (this.salesdata.brand_name == "LE MERITIN") {
          this.designExists = "LM-100";
          this.designList[0].design_no = this.designExists;
        } 
        else if (this.salesdata.brand_name == "MARX") {
          this.designExists = "MX-100";
          this.designList[0].design_no = this.designExists;
        } 
        else {
          this.designExists = "OL-100";
          this.designList[0].design_no = this.designExists;
        }
      }
      for (let i = 0; i <= this.salesdata.total_design; i++) {
        if (i == this.salesdata.total_design - 1) {
          return;
        }
        let rowdetail = Object.assign({}, this.row);
        this.designList.push(rowdetail);

        let ind = this.designList.length - 1;

        if (this.salesdata.brand_name == "LEO BOYS") {
          this.designList[this.designList.length - 1].design_no =
            "LB-" + (Number(this.runningDesigns) + ind);
        }
        else if (this.salesdata.brand_name == "JOB") {
          this.designList[this.designList.length - 1].design_no =
            "JB-" + (Number(this.runningDesigns) + ind);
        } 
        else if (this.salesdata.brand_name == "LE MERITIN") {
          this.designList[this.designList.length - 1].design_no =
            "LM-" + (Number(this.runningDesigns) + ind);
        } 
        else if (this.salesdata.brand_name == "MARX") {
          this.designList[this.designList.length - 1].design_no =
            "MX-" + (Number(this.runningDesigns) + ind);
        }
        else {
          this.designList[this.designList.length - 1].design_no =
            "OL-" + (Number(this.runningDesigns) + ind);
        }
        console.log(this.designList);
      }
    });
  }

  checkColor(design_id, ind) {
    for (var k = 0; k < this.designList.length; k++) {
      let temp = this.designList[k];
      if (design_id > 0) {
        if (temp.design_id == design_id && ind !== k) {
          swal("DESIGN AND COLOR ALREADY EXIST");
          this.designList[ind].design_no = "";
          this.designList[ind].color = "";
          this.designList[ind].design_id = 0;
        }
      }
    }
  }
  onShowdamage() {
    let rowdetail = Object.assign({}, this.damrow);
    this.damageList.push(rowdetail);

    let baldetail = Object.assign({}, this.balrow);
    this.bal_bitList.push(baldetail);

    this.designList.forEach((el) => {
      if (el.qty > 0) {
        this.desList.push({ des: el.design_no, shade: el.color });
      }
    });
    console.log(this.desList);
    if (this.salesdata.dc_type == "BULK") {
      this.designList.forEach((el) => {
        if (el.totqty > 0) {
          this.desList.push({ des: el.design_no, shade: el.color });
        }
      });
      if (this.salesdata.style == "BABLA") {
        this.sizeList = [
          "F28",
          "F30",
          "F32",
          "F34",
          "F36",
          "H28",
          "H30",
          "H32",
          "H34",
          "H36",
        ];
      } else if (this.salesdata.style == "SHIRT") {
        this.sizeList = [
          "F36",
          "F38",
          "F40",
          "F42",
          "F44",
          "F46",
          "H36",
          "H38",
          "H40",
          "H42",
          "H44",
          "H46",
        ];
      }
    }
  }
  onSelectshade(type, ind) {
    let temp = this.desList.filter((el) => el.des == type);
    let dshade = temp[0].shade;

    this.damageList[ind].dshade = dshade;
    console.log(type);
    this.show_button = true;
  }
  onSelectBaldesign(des, ind) {
    this.show_balbutt = true;
    let obj = this.dcDetails;
this.tempList = obj.filter((el) => el.fab_design_no == des);

    console.log(this.tempList);
    // let barcode = temp[0].barcode;
    // this.bal_bitList[ind].bal_barcode = barcode;

  }
  tableStyle() {
    const style = {
      margin: "auto",
      width: this.salesdata.dc_type === "BULK" ? "95%" : "56%",
    };
    return style;
  }

  onSelectbrand(brand) {
    this.job_type_check = false;
    this.brand_check = false;
    this.expose_type_check = false;

    // this.salesdata.brand_name = brand;
    // this.designList[0].design_no = '';
    // if (this.salesdata.brand_name == "OTHER BRANDS") {

    //   this.brand_check = true;
    // } else if (this.salesdata.brand_name == "JOB") {

    //   this.job_type_check = true;
    // }
    //   this.expose_type_check = true;
    //   this.designList[0].design_no = this.designExists;
  }

  // onSelectStyle(style){
  //   if(style == 'FORMAL' || style == 'STYLISH FORMAL'){
  //     this.salesdata.fit = "COMFORT FIT";
  //   }else if(style == 'CASUAL'){
  //     this.salesdata.fit = "RELAX FIT";
  //   }else if(style == 'CLUBWEAR'){
  //     this.salesdata.fit = "SLIM FIT";
  //   }
  // }
  onSelectType($event, ind) {
    this.designList[ind]["typeid"] = $event.item.id;
  }

  //   getTypeList() {
  //     let params = {};
  //     this.comboservice.gettypeList().then((res: any) => {
  //       this.shirttypeList = res;
  //     });
  //   }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
      this.tempDesignnoList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  onSelectColor(design, color, ind) {
    if (isNaN(color)) {
      color = color.toUpperCase();
    }
    this.colorList.forEach((element) => {
      if (color == element.dispName) {
        //     this.designList[ind]['des_id'] = element.des_id;
        this.designList[ind]["design_id"] = element.design_id;
        this.designList[ind]["shade"] = element.dispName;
      }
    });

    for (var k = 0; k < this.designList.length; k++) {
      let temp = this.designList[k];
      if (temp.design_id == this.designList[ind].design_id && !k == ind) {
        swal("DESIGN AND COLOR ALREADY EXISTS");
      }
    }
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      //   this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    let design = this.designList;

    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.designList = desList;
    this.onSaveOrder();
  }

  onSaveOrder(): void {

    let dataList = [];
    dataList = this.designList.filter((el) => el.qty > 0);

    if (this.salesdata.dc_type == "BULK") {
      let tot = 0;
      // this.designList.forEach((el) => {
      //   tot += Number(el.totqty);
      //   this.salesdata.totqty = tot;
      // });
      console.log(this.salesdata.totqty);
      dataList = this.designList.filter((el) => el.totqty > 0);

    }

    if (!this.salesdata.dqty) {
      this.salesdata.dqty = 0;
    }
    this.salesdata.totInw_pcs = this.salesdata.dqty + this.salesdata.totqty;
    this.salesdata.tot_recpcs = this.salesdata.totInw_pcs + this.salesdata.rec_pcs;

    console.log(dataList);
    console.log(this.salesdata);

    if (this.salesdata.brand_name == undefined) {
      swal("Make sure that all the details are entered!");
    } else {
      let params: any = Object.assign({}, this.salesdata);
      params["tabevent"] = undefined;
      params["mode"] = this.mode;
      params["designList"] = JSON.stringify(dataList);
      params["damageList"] = JSON.stringify(this.damageList);
      params["balList"] = JSON.stringify(this.bal_bitList);
      params["inward_date"] = this.datePipe.transform(
        params["inward_date"],
        "yyyy-MM-dd"
      );
      params["purchase_date"] = this.datePipe.transform(
        params["purchase_date"],
        "yyyy-MM-dd"
      );

      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this brand stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.dcService
          .adduptJobworkInward(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.message) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {
      let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
      }, []);
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitDc/AddbitDcInward.ts